// extracted by mini-css-extract-plugin
export var paginationContainer = "_1o-0";